export default "__VITE_ASSET__CvDPUgI9__"